import React, { Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router";
import { createPaywallRoutes } from "./paywallRoutes";
import { prodLog } from "@v2/shared/lib/logger";

export const BrowserProvider = () => {
  const router = React.useMemo(() => {
    prodLog("BrowserProvider: creating router");
    return createBrowserRouter(createPaywallRoutes());
  }, []);

  return (
    <Suspense fallback={<LoaderPage />}>
      <RouterProvider router={router} />
    </Suspense>
  );
};

const LoaderPage = React.lazy(() =>
  import("@v2/pages/loaderPage/loaderPage.ui").then((module) => ({
    default: module.LoaderPage,
  }))
);
